import React from 'react';
import { Helmet } from 'react-helmet-async';
import Header from '../inc/header';
import Footer from '../inc/footer';

function CookiePolicy() {
    return (
        <>
            <Helmet>
                <title>Cookie Policy | Radius Exhibition Fixtures</title>
            </Helmet>

            <style>
                {`
                /* ====== General Typography ====== */
                #content_section p, ul, h1, h4 {
                    text-align: justify !important;
                    color: #000;
                }

                .service-description {
                    text-align: justify !important;
                    color: #000;
                    line-height: 1.8;
                }

                .service-description ul li::marker {
                    color: #E6178B !important;
                }

                .service-description h4 {
                    color: #272761;
                    font-weight: 700;
                    margin-top: 30px;
                    margin-bottom: 15px;
                }

                .service-description p, .service-description ul {
                    margin-bottom: 15px;
                }

                /* ====== Page Header ====== */
                .page-header {
                    background-size: cover;
                    background-position: center;
                    color: #fff;
                    padding: 100px 0;
                }

                .page-header h1 {
                    font-weight: 700;
                    color: #fff;
                }

                /* ====== Mobile Optimization ====== */
                @media (max-width: 768px) {
                    .page-header {
                        padding: 60px 0;
                    }
                }

                /* ====== Link Styling ====== */
                .text-pink {
                    color: #E6178B !important;
                }

                a.text-pink:hover {
                    text-decoration: underline;
                }
                `}
            </style>

            <Header />

            <main role="main" className="main">
                {/* ======= PAGE HEADER ======= */}
                <section
                    className="page-header page-header-modern page-header-background overlay overlay-color-dark overlay-show overlay-op-7"
                    style={{
                        backgroundImage: "url('/assets/img/slides/page-header-services.jpg')",
                    }}
                >
                    <div className="container">
                        <div className="row mt-5">
                            <div className="col-md-12 align-self-center text-center">
                                <h1 className="text-10">
                                    <strong>Cookie Policy</strong>
                                </h1>
                            </div>
                        </div>
                    </div>
                </section>

                {/* ======= CONTENT SECTION ======= */}
                <div className="container py-5">
                    <div className="row justify-content-center">
                        <div className="col-lg-10 col-md-12">
                            <div className="service-description">

                                <p>
                                    At <strong>Gulf Strategic Partners Co. (GSP)</strong>, we are committed to protecting your privacy.
                                    This Cookie Policy explains how we use cookies and similar technologies on our website:
                                    <a href="https://www.gspwll.com" target="_blank" rel="noreferrer" className="text-pink ms-1">www.gspwll.com</a>.
                                    By using our website, you agree to our use of cookies as described in this policy.
                                </p>

                                <h4>1. What Are Cookies?</h4>
                                <p>
                                    Cookies are small text files that are stored on your device (computer, smartphone, or tablet)
                                    when you visit a website. They help the site remember your preferences and improve your experience.
                                </p>
                                <p>Cookies can be:</p>
                                <ul>
                                    <li><strong>Session cookies</strong> – temporary and deleted when you close your browser.</li>
                                    <li><strong>Persistent cookies</strong> – remain on your device until they expire or are deleted.</li>
                                </ul>

                                <h4>2. How We Use Cookies</h4>
                                <p>We use cookies to:</p>
                                <ul>
                                    <li>Ensure the website functions properly.</li>
                                    <li>Understand how visitors use our website.</li>
                                    <li>Improve performance and user experience.</li>
                                    <li>Remember your preferences and settings.</li>
                                    <li>Support security and authentication.</li>
                                </ul>

                                <h4>3. Types of Cookies We Use</h4>
                                <div className="table-responsive">
                                    <table className="table table-bordered">
                                        <thead style={{ backgroundColor: '#272761', color: '#fff' }}>
                                            <tr>
                                                <th>Type</th>
                                                <th>Purpose</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>Essential Cookies</td>
                                                <td>Necessary for basic site functions (e.g., navigation, access).</td>
                                            </tr>
                                            <tr>
                                                <td>Analytics Cookies</td>
                                                <td>Help us understand how users interact with our website.</td>
                                            </tr>
                                            <tr>
                                                <td>Functionality Cookies</td>
                                                <td>Remember choices (e.g., language, region).</td>
                                            </tr>
                                            <tr>
                                                <td>Third-Party Cookies</td>
                                                <td>Set by external services we use (e.g., Google Analytics).</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>

                                <h4>4. Third-Party Cookies</h4>
                                <p>
                                    We may use third-party services (such as Google Analytics) to help analyze how users use our site.
                                    These services may set their own cookies on your device.
                                </p>
                                <p>
                                    For more information, please visit the respective privacy policies of these third parties.
                                </p>

                                <h4>5. Managing and Disabling Cookies</h4>
                                <p>Most web browsers allow you to control cookies through your browser settings. You can:</p>
                                <ul>
                                    <li>View what cookies are stored.</li>
                                    <li>Delete cookies.</li>
                                    <li>Block cookies entirely or from specific sites.</li>
                                </ul>
                                <p>
                                    Please note that disabling certain cookies may impact the functionality and performance of our website.
                                </p>

                                <p>To manage your cookie settings, visit:</p>
                                <ul>
                                    <li><strong>Chrome:</strong> <a href="chrome://settings/cookies" className="text-pink">chrome://settings/cookies</a></li>
                                    <li><strong>Firefox:</strong> <a href="about:preferences#privacy" className="text-pink">about:preferences#privacy</a></li>
                                    <li><strong>Safari:</strong> Preferences &gt; Privacy</li>
                                    <li><strong>Edge:</strong> <a href="edge://settings/content/cookies" className="text-pink">edge://settings/content/cookies</a></li>
                                </ul>

                                <h4>6. Updates to This Cookie Policy</h4>
                                <p>
                                    We may update this Cookie Policy from time to time to reflect changes in our practices or legal obligations.
                                    Any updates will be posted on this page with a revised "Effective Date."
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </main>

            <Footer />
        </>
    );
}

export default CookiePolicy;
